export const useCssVar = (elRef, id) => {
  const value = ref(null)

  const update = function () {
    if (!elRef.value) return
    value.value = getComputedStyle(elRef.value).getPropertyValue(id)
  }
  onMounted(update)
  watch(() => [elRef.value, id], update)
  useResize2(update)

  return value
}
